import { render, staticRenderFns } from "./podiumView.vue?vue&type=template&id=9fc293c4&scoped=true&"
import script from "./podiumView.vue?vue&type=script&lang=js&"
export * from "./podiumView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc293c4",
  null
  
)

export default component.exports